import { useCurrency } from '../../util/CurrencyContext'

const CurrencyFormat = ({ amount, className = '', decimal = 0 }) => {
    const { currencySymbol, currencyRate } = useCurrency()
    const converted = (amount * currencyRate).toFixed(decimal)

    const formatted = new Intl.NumberFormat(undefined, {
        minimumFractionDigits: decimal,
        maximumFractionDigits: decimal,
    }).format(converted)

    return (
        <span className={className}>
            {currencySymbol}
            {formatted}
        </span>
    )
}

export default CurrencyFormat
